module.exports = __webpack_public_path__ + "static/media/hourglass-end.0f670907.png";